import { createContext } from 'react'

export interface MouseSelectionContextType {
  hasMouseSelection: boolean
}

export const MouseSelectionContext = createContext<MouseSelectionContextType | undefined>(undefined)
